export class Config {
    get systemName() {
        return this.getValue('systemName');
    }
    get appURL() {
        return this.getValue('appURL');
    }
    get beURL() {
        return this.getValue('beURL');
    }
    get feURL() { // this config is for BE systems
        return this.getValue('feURL');
    }
    get homePageGroupsLink() {
        return this.getValue('homePageGroupsLink');
    }
    get registration() {
        return this.getValue('registration');
    }
    get redirectRootUrl() {
        return this.getValue('redirectRootUrl');
    }
    get groupsMenuBgImg() {
        return this.getValue('groupsMenuBgImg');
    }
    get isDam() {
        return this.getValue('isDam');
    }
    get isWebComponent() {
        return this.getValue('isWebComponent');
    }
    get loginRedirect() {
        return this.getValue('loginRedirect');
    }
    get activationRedirect() {
        return this.getValue('activationRedirect');
    }
    get newsletterRedirect() {
        return this.getValue('newsletterRedirect');
    }
    get varietyRedirect() {
        return this.getValue('varietyRedirect');
    }
    get imagesPath() {
        return this.getValue('imagesPath');
    }
    get deliveryProductCode() {
        return this.getValue('deliveryProductCode');
    }
    get loadGroupTags() {
        return this.getValue('loadGroupTags');
    }
    get productRelatedItems() {
        return this.getValue('productRelatedItems');
    }
    get productConflictedItems() {
        return this.getValue('productConflictedItems');
    }
    get hidePopoverByScrollElements() {
        return this.getValue('hidePopoverByScrollElements');
    }
    get productRelatedItemsField() {
        return this.getValue('productRelatedItemsField');
    }
    get productRelatedItemsGrid() {
        return this.getValue('productRelatedItemsGrid');
    }
    get item_per_page() {
        return this.getValue('item_per_page');
    }
    get logoPath() {
        return this.getValue('logoPath');
    }
    get dataEntry() {
        return this.getValue('dataEntry');
    }
    get noImagePic() {
        return this.getValue('noImagePic');
    }
    get productImagesPath() {
        return this.getValue('productImagesPath');
    }
    get productTabContexts() {
        return this.getValue('productTabContexts');
    }
    get productTabRelatedContexts() {
        return this.getValue('productTabRelatedContexts');
    }
    get contactUsURL() {
        return this.getValue('contactUsURL');
    }
    get catalog_selection_fields() {
        return this.getValue('catalog_selection_fields');
    }
    get show_products_by_group() {
        return this.getValue('show_products_by_group');
    }
    get noSidebar() {
        return this.getValue('noSidebar');
    }
    get catalogue_routes_type() {
        return this.getValue('catalogue_routes_type') || [];
    }
    get disable_friendly_url() {
        return this.getValue('disable_friendly_url');
    }
    get productPageMainTitleField() {
        return this.getValue('productPageMainTitleField');
    }
    get productPageSecondaryTitleField() {
        return this.getValue('productPageSecondaryTitleField');
    }
    get productCardMainTitleField() {
        return this.getValue('productCardMainTitleField');
    }
    get productCardSecondaryTitleField() {
        return this.getValue('productCardSecondaryTitleField');
    }
    get familyCardMainTitleField() {
        return this.getValue('familyCardMainTitleField');
    }
    get familyCardSecondaryTitleField() {
        return this.getValue('familyCardSecondaryTitleField');
    }
    get cngPageMainTitleField() {
        return this.getValue('cngPageMainTitleField');
    }
    get cngPageSecondaryTitleField() {
        return this.getValue('cngPageSecondaryTitleField');
    }
    get headerCmsName() {
        return this.getValue('headerCmsName');
    }
    get footerCmsName() {
        return this.getValue('footerCmsName');
    }
    get personalAccountLink() {
        return this.getValue('personalAccountLink');
    }
    get defaultLang() {
        return this.getValue('defaultLang');
    }
    get useLangSubDomain() {
        return this.getValue('useLangSubDomain');
    }
    get isMultiLanguages() {
        return this.getValue('isMultiLanguages');
    }
    get groupByProductInSearch() {
        return this.getValue('groupByProductInSearch');
    }
    get skipQueryParamKeys() {
        return this.getValue('skipQueryParamKeys');
    }
    get unCommerceApp() {
        return this.getValue('unCommerceApp');
    }
    set unCommerceApp(value) {
        this.setValue('unCommerceApp', value);
    }
    set catalogueBlocks(value) {
        this.setValue('catalogueBlocks', value);
    }
    get commerceApp() {
        return this.getValue('commerceApp');
    }
    get compareProduct() {
        return this.getValue('compareProduct');
    }
    get solr_parameters() {
        return this.getValue('solr_parameters');
    }
    get mainFormFieldsCount() {
        return this.getValue('mainFormFieldsCount');
    }
    get qNumEachStepMainFrm() {
        return this.getValue('qNumEachStepMainFrm');
    }
    get checkAccountLimit() {
        return this.getValue('checkAccountLimit');
    }

    get orgUserDetailsShowMoreData() {
        return this.getValue('orgUserDetailsShowMoreData');
    }
    get ssoDomain() {
        return this.getValue('ssoDomain');
    }
    get gadgets() {
        return this.getValue('gadgets');
    }
    get disableSeo() {
        return this.getValue('disableSeo');
    }
    get login() {
        return this.getValue('login');
    }
    get accountCmsTop() {
        return this.getValue('accountCmsTop');
    }
    get restrictedLogin() {
        return this.getValue('restrictedLogin');
    }
    get contactUsNewsLatters() {
        return this.getValue('contactUsNewsLatters');
    }
    get loginAdminRedirect() {
        return this.getValue('loginAdminRedirect');
    }
    get debugMode() {
        return this.getValue('debugMode');
    }
    get rootGroupSlug() {
        return this.getValue('rootGroupSlug');
    }
    get injectExternalResources() {
        return this.getValue('injectExternalResources');
    }
    get disableExternalResources() {
        return this.getValue('disableExternalResources');
    }
    get fixedHeader() {
        return this.getValue('fixedHeader');
    }
    get apiBeURL() {
        return this.getValue('apiBeURL');
    }
    get accountCmsBottom() {
        return this.getValue('accountCmsBottom');
    }
    get threshold() {
        return this.getValue('threshold');
    }
    get fieldFacetFilter() {
        return this.getValue('fieldFacetFilter');
    }
    get carouselHP() {
        return this.getValue('carouselHP');
    }
    get solrSearchQf() {
        return this.getValue('solrSearchQf');
    }
    get catalogueSort() {
        return this.getValue('catalogueSort');
    }
    get showTotalSaved() {
        return this.getValue('showTotalSaved');
    }
    get priceDisplay(){
        return this.getValue('priceDisplay');
    }
    get priceCurrentLabel(){
        return this.getValue('priceCurrentLabel');
    }
    get priceFractionDigits(){
        return this.getValue('priceFractionDigits');
    }
    get productOvFields() {
        return this.getValue('productOvFields');
    }
    get miniCart() {
        return this.getValue('miniCart');
    }
    get showCoupon() {
        return this.getValue('showCoupon');
    }
    get inventoryCheck() {
        return this.getValue('inventoryCheck');
    }
    get inventoryCheckType() {
        return this.getValue('inventoryCheckType');
    }
    get cartCms() {
        return this.getValue('cartCms');
    }
    get splitAutoCompleteSearchResults() {
        return this.getValue('splitAutoCompleteSearchResults');
    }
    get searchSections() {
        return this.getValue('searchSections');
    }
    get tracking() {
        return this.getValue('tracking');
    }
    get clubRegistrationLink() {
        return this.getValue('clubRegistrationLink');
    }
    get compare_context_id() {
        return this.getValue('compare_context_id');
    }
    get groupBannerLayout() {
        return this.getValue('groupBannerLayout');
    }
    get mobileMenuTreeNavigateLeafOnly() {
        return this.getValue('mobileMenuTreeNavigateLeafOnly');
    }
    get gaSendSearchTerms() {
        return this.getValue('gaSendSearchTerms');
    }
    get previousOrdersColumns() {
        return this.getValue('previousOrdersColumns');
    }
    get trackingPerOrder() {
        return this.getValue('trackingPerOrder');
    }
    get productTabContextLayout() {
        return this.getValue('productTabContextLayout');
    }
    get GroupBannerCheck() {
        return this.getValue('GroupBannerCheck');
    }
    get checkAvailabilityIframe() {
        return this.getValue('checkAvailabilityIframe');
    }
    get institutionLogoGroupId() {
        return this.getValue('institutionLogoGroupId');
    }
    get mainDescription(){
        return this.getValue('mainDescription');
    }
    get mainSecondaryDescription(){
        return this.getValue('mainSecondaryDescription');
    }
    get archiveStorage(){
        return this.getValue('archiveStorage');
    }
    get replacePipeWith(){
        return this.getValue('replacePipeWith');
    }
    get cngComponentImageExtention(){
        return this.getValue('cngComponentImageExtention');
    }
    get mobileBreakPoint(){
        return this.getValue('mobileBreakPoint');
    }
    get gridBreakPoints(){
        return this.getValue('gridBreakPoints');
    }
    get linkMedia(){
        return this.getValue('linkMedia');
    }
    get assetsLink(){
        return this.getValue('assetsLink');
    }
    get displayItemsMode(){
        return this.getValue('displayItemsMode');
    }
    get doNotRedirectSingleProduct(){
        return this.getValue('doNotRedirectSingleProduct');
    }
    get doNotRedirectSingleGroup(){
        return this.getValue('doNotRedirectSingleGroup');
    }
    get familyCardImagesExtension(){
        return this.getValue('familyCardImagesExtension');
    }
    get cngProdutPicFccTag() {
        return this.getValue('cngProdutPicFccTag');
    }
    get showCookieDisclaimer() {
        return this.getValue('showCookieDisclaimer');
    }
    get fictiveGroupLevel1Id() {
        return this.getValue('fictiveGroupLevel1Id');
    }
    get iframeFeedbackParams() {
        return this.getValue('iframeFeedbackParams');
    }

    get dependedFilters() {
        return this.getValue('dependedFilters');
    }
    get hiddenFilters() {
        return this.getValue('hiddenFilters');
    }
    get breadcrumbsCatalogHomeURL() {
        return this.getValue('breadcrumbsCatalogHomeURL');
    }
    get productCardProperty1Field() {
        return this.getValue('productCardProperty1Field');
    }
    get productCardProperty2Field() {
        return this.getValue('productCardProperty2Field');
    }
    get productCardProperty3Field() {
        return this.getValue('productCardProperty3Field');
    }
    get productCardProperty4Field() {
        return this.getValue('productCardProperty4Field');
    }
    get quickOrderPadComponents() {
        return this.getValue('quickOrderPadComponents');
    }
    get cartIndication() {
        return this.getValue('cartIndication');
    }
    get quickOrderPadQtyField() {
        return this.getValue('quickOrderPadQtyField');
    }
    get matomo() {
        return this.getValue('matomo');
    }
    get mediaCardSecondaryTitleField() {
        return this.getValue('mediaCardSecondaryTitleField');
    }
    get mediaCardTitleField() {
        return this.getValue('mediaCardTitleField');
    }
    get solr_media_parameters() {
        return this.getValue('solr_media_parameters');
    }
    get previewTypes() {
        return this.getValue('previewTypes');
    }
    get parentsMediaTypes() {
        return this.getValue('parentsMediaTypes');
    }
    get selectionCategoryMode() {
        return this.getValue('selectionCategoryMode');
    }
    get mediaMainDescription() {
        return this.getValue('mediaMainDescription');
    }
    get mediaSecondaryDescription() {
        return this.getValue('mediaSecondaryDescription');
    }
    get mediaProductDetailsContext() {
        return this.getValue('mediaProductDetailsContext');
    }
    get showRelatedProductsMedia() {
        return this.getValue('showRelatedProductsMedia');
    }
    get scannerProductFields() {
        return this.getValue('scannerProductFields');
    }
    get contactUsLink() {
        return this.getValue('contactUsLink');
    }
    get paymentSourceDomain() {
        return this.getValue('paymentSourceDomain');
    }

    get hideAutocompleteToDate() {
        return this.getValue('hideAutocompleteToDate');
    }

    get timeUntilClearInvalidDate() {
        return this.getValue('timeUntilClearInvalidDate');
    }

    get phoneValidation() {
        return this.getValue('phoneValidation');
    }

    get showWelcomeNotification() {
        return this.getValue('showWelcomeNotification');
    }

    get newsletters() {
        return this.getValue('newsletters');
    }

    get sessionVariety() {
        return this.getValue('sessionVariety');
    }

    get solrFieldsFilters() {
        return this.getValue('solrFieldsFilters');
    }

    get permissiedTabsComponent() {
        return this.getValue('permissiedTabsComponent');
    }

    get captchaPublicKey() {
        return this.getValue('captchaPublicKey');
    }
    get captchaShowAfterAttempts() {
        return this.getValue('captchaShowAfterAttempts');
    }

    get concatAnsToDependValues() {
        return this.getValue('concatAnsToDependValues');
    }
    get hideProductImageBox() {
        return this.getValue('hideProductImageBox');
    }

    get cartProductLimitCount() {
        return this.getValue('cartProductLimitCount');
    }

    get allowedFilterValuesForPivot() {
        return this.getValue('allowedFilterValuesForPivot');
    }

    get testCng() {
        return this.getValue('testCng');
    }

    get homepageNotificationLength() {
        return this.getValue('homepageNotificationLength');
    }

    get searchExactMatch() {
        return this.getValue('searchExactMatch');
    }

    get searchEntity() {
        return this.getValue('searchEntity');
    }

    get regLoginCms() {
        return this.getValue('regLoginCms');
    }

    get cngCurrency() {
        return this.getValue('cngCurrency');
    }

    get regLoginCarouselConfig() {
        return this.getValue('regLoginCarouselConfig');
    }

    get searchAutocompleteEntity() {
        return this.getValue('searchAutocompleteEntity');
    }


    get family_context_fields() {
        return this.getValue('family_context_fields');
    }

    get ngxCarouselConfig() {
        return this.getValue('ngxCarouselConfig');
    }

    get ngxGalleryConfig() {
        return this.getValue('ngxGalleryConfig');
    }

    get showNetPriceTooltip() {
        return this.getValue('showNetPriceTooltip');
    }

    get POSLineProducts() {
        return this.getValue('POSLineProducts');
    }

    get numberingMap() {
        return this.getValue('numberingMap');
    }

    get currencySymbol() {
        return this.getValue('currencySymbol');
    }

    get maxQuantityInCart() {
        return this.getValue('maxQuantityInCart');
    }

    get maxOrderLinesInCart() {
        return this.getValue('maxOrderLinesInCart');
    }

    get firstLoginRedirect() {
        return this.getValue('firstLoginRedirect');
    }

    get entityBreadcrumbSeparator() {
        return this.getValue('entityBreadcrumbSeparator');
    }

    get entityBreadcrumbHomeType() {
        return this.getValue('entityBreadcrumbHomeType');
    }

    get filterGadget() {
        return this.getValue('filterGadget');
    }

    get orderType() {
        return this.getValue('orderType');
    }

    get apiCacheToken() {
        return this.getValue('apiCacheToken');
    }

    get omitLettersForFacetSort() {
        return this.getValue('omitLettersForFacetSort');
    }
    get commonUnitForFacetSort() {
        return this.getValue('commonUnitForFacetSort');
    }
    get newOverviewPage() {
        return this.getValue('newOverviewPage');
    }
    get cancelPolicyEntityVar() {
        return this.getValue('cancelPolicyEntityVar');
    }
    get pickupEntityVar() {
        return this.getValue('pickupEntityVar');
    }
    get serialFields() {
        return this.getValue('serialFields');
    }
    get showFullCatTreeOnNavigate() {
        return this.getValue('showFullCatTreeOnNavigate');
    }
    get distributionChannelId() {
        return this.getValue('distributionChannelId');
    }
    get ngxTreeConfig() {
        return this.getValue('ngxTreeConfig');
    }
    get homePageBlockVar() {
        return this.getValue('homePageBlockVar');
    }
    get homePageEntityVar() {
        return this.getValue('homePageEntityVar');
    }
    get ngxCategoryMenu() {
        return this.getValue('ngxCategoryMenu');
    }
    get ngxGovMaps() {
        return this.getValue('ngxGovMaps');
    }
    get selectGadget() {
        return this.getValue('selectGadget');
    }

    get paymetricScript() {
        return this.getValue('paymetricScript');
    }

    get paymentScript() {
        return this.getValue('paymentScript');
    }

    get showCityLocation() {
        return this.getValue('showCityLocation');
    }

    get reflections() {
        return this.getValue('reflections');
    }

    get quickOrderPadSampleTab() {
        return this.getValue('quickOrderPadSampleTab');
    }

    get debugRules() {
        return this.getValue('debugRules');
    }

    get bucketCardMainTitleField() {
        return this.getValue('bucketCardMainTitleField');
    }

    get bucketCardSecondaryTitleField() {
        return this.getValue('bucketCardSecondaryTitleField');
    }

    get addressFormFields() {
        return this.getValue('addressFormFields');
    }

    get redirectAfterChangeLang() {
        return this.getValue('redirectAfterChangeLang');
    }

    get autoCloseModal() {
        return this.getValue('autoCloseModal');
    }

    get disabledEmailDomains() {
        return this.getValue('disabledEmailDomains');
    }
    get hideNameInNewsletter() {
        return this.getValue('hideNameInNewsletter');
    }
    get getEntityByApi() {
        return this.getValue('getEntityByApi');
    }
    get favicon() {
        return this.getValue('favicon');
    }
    get userDetailsFieldName() {
        return this.getValue('userDetailsFieldName');
    }

    get redirectByReplaceRegex() {
        return this.getValue('redirectByReplaceRegex');
    }

    get fullBaseImagesPath() {
        return `${this.imagesPath}/${this.systemName}`;
    }

    get siteDomains() {
        return this.getValue('siteDomains');
    }

    get siteData() {
        return this.getValue('siteData');
    }

    get shippingCostMessage() {
        return this.getValue('shippingCostMessage');
    }

    get stripePK() {
        return this.getValue('stripePK');
    }

    get appNonUsers() {
        return this.getValue('appNonUsers');
    }

    get shapeFiles() {
        return this.getValue('shapeFiles');
    }
    get adminRoutes() {
        return this.getValue('adminRoutes');
    }

    get catalogueEntityBlock() {
        return this.getValue('catalogueEntityBlock');
    }

    get canonicalProductPagePath() {
        return this.getValue('canonicalProductPagePath');
    }

    get cngComponentsLoader(){
        return this.getValue('cngComponentsLoader');
    }

    get fixedHeaderHeight(){
        return this.getValue('fixedHeaderHeight');
    }

    get routeBlockStyle() {
        return this.getValue('routeBlockStyle');
    }

    get disableUpdatingFieldWhenSameKeyChange(){
        return this.getValue('disableUpdatingFieldWhenSameKeyChange');
    }

    get wizWidgetsEntityType() {
        return this.getValue('wizWidgetsEntityType');
    }

    get registrationErrors() {
        return this.getValue('registrationErrors');
    }

    get additionalGroupData() {
        return this.getValue('additionalGroupData');
    }
    get CDNPrefix() {
        return this.getValue('CDNPrefix');
    }

    get diable_friendly_url() {
        return this.getValue('diable_friendly_url');
    }

    get support() {
        return this.getValue('support');
    }

    get productPreviewVar() {
        return this.getValue('productPreviewVar');
    }

    get productPageUrlField() {
        return this.getValue('productPageUrlField');
    }
    get cdn() {
        return this.getValue('cdn');
    }

    get multiExtensionImageGroup() {
        return this.getValue('multiExtensionImageGroup');
    }

    get familyPreviewVar() {
        return this.getValue('familyPreviewVar');
    }

    get maximumTaxonomyLevelsInCatalog() {
        return this.getValue('maximumTaxonomyLevelsInCatalog');
    }

    get orgMaxLevels() {
        return this.getValue('orgMaxLevels');
    }

    get groupsTreeCarriedFilters() {
        return this.getValue('groupsTreeCarriedFilters');
    }

    get setHreflang() {
        return this.getValue('setHreflang');
    }

    get all() {
        return (<any>window).GenericConfig ? (<any>window).GenericConfig: [];
    }

    getValue(key) {
        return (<any>window).GenericConfig ? (<any>window).GenericConfig[key]: undefined;
    }

    get useProductFullSolrDTO() {
        return this.getValue('useProductFullSolrDTO');
    }
    get ngxSearchProperties() {
        return this.getValue('ngxSearchProperties');
    }
    get googlePay() {
        return this.getValue('googlePay');
    }

    get showProductStructureData() {
        return this.getValue('showProductStructureData');
    }

    get closeCatalogueTreeOnInit() {
        return this.getValue('closeCatalogueTreeOnInit');
    }

    get GTM_ID() {
        return this.getValue('GTM_ID');
    }

    get userIdle() {
        return this.getValue('userIdle');
    }

    get showQuantity() {
        return this.getValue('showQuantity');
    }

    get openCatalogueFiltersCount() {
        return this.getValue('openCatalogueFiltersCount');
    }

    get useOneCoupon() {
        return this.getValue('useOneCoupon');
    }

    setValue(key, value) {
        if((<any>window).GenericConfig) (<any>window).GenericConfig[key] = value;
    }

    get productItemsInRowOnGridMode() {
        return this.getValue('productItemsInRowOnGridMode');
    }

    get catalogueCardsDisplayMode() {
        return this.getValue('catalogueCardsDisplayMode');
    }

    get hideResultsPerPageSelect() {
        return this.getValue('hideResultsPerPageSelect');
    }

    get showAllProductsInTaxonomy(){
        return this.getValue('showAllProductsInTaxonomy');
    }

    get productPageSwiperImagesConfig() {
        return this.getValue('productPageSwiperImagesConfig');
    }
    get productPageSwiperRelatedProducts() {
        return this.getValue('productPageSwiperRelatedProducts');
    }
    get showLastLogin() {
        return this.getValue('showLastLogin');
    }

}

const GenericConfig = new Config();
export { GenericConfig };
